import { CampaignComponentSocket } from "../../variable/model/CampaignComponentSocket";
import CampaignComponentVariable from "../../variable/model/CampaignComponentVariable";
import { isCampaignComponentVariableResponse } from "src/shared/store/component-built/setting/model/factory/type-guards";
import { isCampaignComponentEnumVariableResponse, isCampaignComponentSocketVariableResponse, isCampaignComponentEnumListVariableResponse, isCampaignComponentComponentIdVariableResponse, } from "../../variable/model/factory/type-guards";
import { CampaignComponentEnumVariable } from "../../variable/model/CampaignComponentEnumVariable";
import { CampaignComponentEnumListVariable } from "../../variable/model/CampaignComponentEnumListVariable";
import { CampaignComponentComponentIdVariable } from "../../variable/model/CampaignComponentComponentIdVariable";
import { CampaignComponentPartnerEnumVariable } from "../../variable/model/CampaignComponentPartnerEnumVariable";
import { CampaignComponentPartnerEnumListVariable } from "../../variable/model/CampaignComponentPartnerEnumListVariable";
import { isCampaignComponentPartnerEnumVariableResponse, isCampaignComponentPartnerEnumListVariableResponse, } from "../../variable/model/factory/type-guards";
export const createCampaignComponentSetting = (response, context) => {
    if (isCampaignComponentEnumVariableResponse(response)) {
        return new CampaignComponentEnumVariable(response, context);
    }
    else if (isCampaignComponentSocketVariableResponse(response)) {
        return new CampaignComponentSocket(response, context);
    }
    else if (isCampaignComponentEnumListVariableResponse(response)) {
        return new CampaignComponentEnumListVariable(response, context);
    }
    else if (isCampaignComponentPartnerEnumVariableResponse(response)) {
        return new CampaignComponentPartnerEnumVariable(response, context);
    }
    else if (isCampaignComponentPartnerEnumListVariableResponse(response)) {
        return new CampaignComponentPartnerEnumListVariable(response, context);
    }
    else if (isCampaignComponentComponentIdVariableResponse(response)) {
        return new CampaignComponentComponentIdVariable(response, context);
    }
    else if (isCampaignComponentVariableResponse(response)) {
        return new CampaignComponentVariable(response, context);
    }
    return null;
};
export const createCampaignComponentSettings = (responses, context) => {
    const settings = [];
    responses.forEach((response) => {
        const setting = createCampaignComponentSetting(response, context);
        if (setting) {
            settings.push(setting);
        }
    });
    return settings;
};
